import React from "react";
import { Link } from "react-router-dom";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/privacy.scss";

const faqs = [
  ["When will my order ship?", "In-stock orders normally leave our fulfillment partner within 1–3 business days. Tracking is emailed after carrier pickup."],
  ["How much is shipping?", `Tracked shipping is a flat ${formatPrice(siteConfig.commerce.standardShipping)} per order. Any destination taxes or customs charges are shown or assessed separately where applicable.`],
  ["Can I change my order?", "Contact us as soon as possible. We cannot guarantee changes after warehouse processing has started."],
  ["What is the return window?", "Eligible unused products may be requested for return within 30 days of delivery. Review the Returns page for condition and exclusion details."],
  ["Do you store card information?", "No. Payment details are entered on the secure payment provider page and are not collected by this storefront."],
  ["Which countries can I select?", "Checkout offers supported destinations only and excludes destinations we cannot serve because of sanctions, carrier limitations, or compliance requirements."],
];

export default function Faqs() {
  return (
    <main className="policy-page">
      <header className="policy-page__header">
        <p className="policy-page__eyebrow">HELP / {siteConfig.wordmark}</p>
        <h1>FREQUENTLY<br />ASKED QUESTIONS</h1>
        <p className="policy-page__lede">Quick answers about orders, shipping, returns, and payment.</p>
      </header>
      <div className="policy-page__layout">
        <aside className="policy-page__toc"><p>NEED MORE HELP?</p><Link to="/contact">CONTACT SUPPORT</Link></aside>
        <article className="policy-page__content">
          {faqs.map(([question, answer], index) => (
            <section className="policy-page__section" key={question}>
              <span className="policy-page__section-number">{String(index + 1).padStart(2, "0")}</span>
              <h2>{question.toUpperCase()}</h2><p>{answer}</p>
            </section>
          ))}
        </article>
      </div>
    </main>
  );
}
